import { useEffect, useState } from 'react'

// inst-ui
import { Alert } from '@instructure/ui-alerts'
import { Flex } from '@instructure/ui-flex'

// Child components
import { Header } from './Header.js'
import { Form } from './Form.js'
import { Footer } from './Footer.js'

// Utils
import { camelizeKeys } from '../../../../mc-sdk/case-utils'

export const LoginForm = (props) => {

  const { sAMLRequest, relayState, message: responseMessage } = camelizeKeys(props)

  const [attempting, setAttempting] = useState(false)
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState()

  useEffect(() => {
    if(responseMessage && responseMessage !== '') {
      setErrorMessage(responseMessage)
    }

    if(!sAMLRequest || sAMLRequest === '') {
      setErrorMessage('Not a valid SAML2 request.')
    }
    // disabled on initial eslint-plugin-react-hooks configuration
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setCredentials = ({ login, password }) => {
    setLogin(login)
    setPassword(password)
  }

  const submit = (e) => {
    e.preventDefault()

    if (props.onSubmit) {
      // Storybook actions
      props.onSubmit({sAMLRequest, relayState, login, password})
    } else {
      const isValid = e.target.checkValidity()
      if (!isValid) {
        setErrorMessage('Please correct any form errors.')
      } else {
        setAttempting(true)
        e.target.submit()
      }
    }
  }

  return (
      <Flex alignItems="center" justifyItems="center" margin="xx-large">
        <Flex.Item size="25em">

          <Header/>

          {errorMessage &&(
            <Alert
              variant="error"
              renderCloseButtonLabel="Close"
              margin="small"
              timeout={5000}
              onDismiss={() => {setErrorMessage(null)}}
            >
              {errorMessage}
            </Alert>
          )}

          <Form
            credentials={{ login, password }}
            attempting={attempting}
            onCredentialsChange={setCredentials}
            onSubmit={submit}
            samlRequest={sAMLRequest}
            relayState={relayState}
          />

          <Footer/>

        </Flex.Item>
      </Flex>
  )
}
